export interface PlayerCapabilities {
  materialSwap: boolean;
  variantSwitch: boolean;
  parametricGeometry: boolean;
  snapshots: boolean;
  hotspotSelection: boolean;
  semanticPicking: boolean;
  animation: boolean;
  arMode: boolean;
}

export const DEFAULT_CAPABILITIES: PlayerCapabilities = {
  materialSwap: true,
  variantSwitch: true,
  parametricGeometry: false,
  snapshots: true,
  hotspotSelection: false,
  semanticPicking: false,
  animation: false,
  arMode: false,
};
